import React from 'react';
import { Icon } from './Icon.js';
export const IconChartNews = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M8 5.5C8 6.88071 6.88071 8 5.5 8C4.11929 8 3 6.88071 3 5.5C3 4.11929 4.11929 3 5.5 3C6.88071 3 8 4.11929 8 5.5Z", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M2 18H5L7 21H9L13.1429 13H16L19 7H22", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconChartNews.js.map